import { PureComponent } from 'react';

import Link from 'Component/Link';

import './BlackFridayTop.style';

export class BlackFridayTop extends PureComponent {
    render() {
        return (
            <div block="BlackFridayTop">
                <Link to="/">
                    <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M10 19l-7-7m0 0l7-7m-7 7h18" />
                    </svg>
                    <span>{ __('Back to site') }</span>
                </Link>
            </div>
        )
    }
}

export default BlackFridayTop;
